import serviceAxios from "utils/axios";
import { dispatch } from "redux/store";
import { setFilterEnum, setStore } from "redux/slices/initOptions";
import { toast } from "react-toastify";

import RenderInlineNotification from "components/RenderInlineNotification";
import queryString from "query-string";

const methodType = {
  GET: "get",
  POST: "post",
  PUT: "put",
  DELETE: "delete",
};

export class backendApi {
  /**
   *checkUserAuthStatus
   *
   * @param {*} params
   * @return {*}
   * @memberof backendApi
   */
  checkAuthStatus(authStatusQueryData) {
    const config = {
      url: "/oauth/checkAuthStatus?" + queryString.stringify(authStatusQueryData),
      method: methodType.GET,
    };
    return serviceAxios(config);
  }

  /**
   *oauthRedirectUser
   *
   * @param {*} params
   * @return {*}
   * @memberof backendApi
   */
  oauthRedirectUser(appUserId) {
    const config = {
      url: "/oauth/redirectUser?" + queryString.stringify({ appUserId }),
      method: methodType.GET,
    };
    return serviceAxios(config);
  }

  /**
   *oauthDeauthorize
   *
   * @param {*} params
   * @return {*}
   * @memberof backendApi
   */
  oauthDeauthorize(appUserId) {
    const config = {
      url: "/oauth/deauthorize?" + queryString.stringify({ appUserId }),
      method: methodType.GET,
    };
    return serviceAxios(config);
  }

  /**
   *get suggestion reply
   *
   * @param {*} params
   * @return {*}
   * @memberof backendApi
   */
  getReplySuggestionFromUser(params) {
    const config = {
      url: "/autoReply/getReplySuggestionFromUser",
      method: methodType.POST,
      data: params,
    };
    return serviceAxios(config);
  }

  /**
   *获取模板列表
   *
   * @param {*} params
   * @return {*}
   * @memberof backendApi
   */
  getTemplateList(params) {
    const config = {
      url: "/template/list",
      method: methodType.POST,
      data: params,
    };
    return serviceAxios(config);
  }

  /**
   *获取模板详情
   *
   * @param {*} params
   * @return {*}
   * @memberof backendApi
   */
  getTemplateDeatil(id) {
    const config = {
      url: "/template/detail",
      method: methodType.POST,
      data: { id },
    };
    return serviceAxios(config);
  }

  /**
   *获取模板select数据
   *
   *
   * @return {}
   * @memberof backendApi
   */
  async getTemplatFilterEnum() {
    const config = {
      url: "/template/filterEnum",
      method: methodType.GET,
    };
    return serviceAxios(config);
  }

  /**
   *保存模板信息
   *
   * @param {*} params
   * @return {*}
   * @memberof backendApi
   */
  saveTemplate(params) {
    const config = {
      url: "/template/save",
      method: methodType.POST,
      data: params,
    };
    return serviceAxios(config);
  }

  /**
   *删除模板
   *
   * @param {*} id
   * @return {*}
   * @memberof backendApi
   */
  deleteTemplate(id) {
    const config = {
      url: "/template/delete",
      method: methodType.DELETE,
      data: { id },
    };
    return serviceAxios(config);
  }

  /**
   *获取模板log
   *
   * @param {*} id
   * @return {*}
   * @memberof backendApi
   */
  getTemplateOperationHistory(params) {
    const config = {
      url: "/template/getOperationHistory",
      method: methodType.POST,
      data: params,
    };
    return serviceAxios(config);
  }

  /**
   *获取intent list&mapping数据
   *
   *
   * @return {}
   * @memberof backendApi
   */
  getIntentList() {
    const config = {
      url: "/intent/list",
      method: methodType.POST,
    };
    return serviceAxios(config);
  }
}

const BackendApi = new backendApi();
export default BackendApi;
